<template>
    <div>
        <div class="flex flex-col">
            <div
                id="title-general"
                class="flex flex-col md:flex-row justify-between items-center"
            >
                <div class="flex justify-between items-center">
                    <router-link
                        to="/app/files"
                        class="rounded-full bg-brand-blue flex justify-center items-center p-2"
                    >
                        <span>🏠</span>
                    </router-link>
                    <h1 class="text-3xl">
                        &nbsp;Detalle de archivo
                        <span class="text-theme-primary"> #{{ id }} </span>
                    </h1>
                </div>

                <div class="flex items-center">
                    <custom-tooltip>
                        <app-button icon border @click="copyTo">
                            📑
                        </app-button>
                        <template #tooltip>
                            <div class="content-tooltip">
                                <span> Copiar en portapapeles </span>
                            </div>
                        </template>
                    </custom-tooltip>
                    <custom-switch
                        v-if="$ability.hasPermission('file:Update')"
                        v-model="enabledUpdate"
                    >
                        <span class="text-theme-inverse">🖊</span>
                    </custom-switch>
                </div>
            </div>
            <span>
                Puedes cambiar unicamente el campo alt del archivo. Este campo
                ayuda al posicionamiento de las imágenes.
            </span>
        </div>
        <div v-if="loadedAllData" id="file-features">
            <div class="flex flex-wrap">
                <div v-if="id" class="w-full mt-3 p-0 flex justify-around">
                    <span class="text-left">
                        📆💾 {{ fileComponent.createdAt | date }}
                    </span>
                    <span class="text-left">
                        📆✏ {{ fileComponent.updatedAt | date }}
                    </span>
                </div>
            </div>

            <div class="flex flex-wrap">
                <div v-if="id" class="w-full mt-3 p-0 flex justify-around">
                    <span class="text-left">
                        <span v-if="fileComponent.private" class="text-danger">
                            Privado
                        </span>
                        <span v-else class="text-theme-primary"> Público </span>
                    </span>
                    <span
                        v-if="fileComponent.uploaded"
                        class="text-left text-theme-primary"
                    >
                        Carga con éxito
                    </span>
                    <span v-else class="text-left text-theme-warning">
                        Error en la Carga
                    </span>
                </div>
            </div>

            <div class="flex flex-wrap">
                <div class="w-full md:w-1/2 px-2">
                    <custom-input
                        v-model="fileComponent.url"
                        label="Url"
                        disabled
                    />
                </div>
                <div class="w-full md:w-1/2 px-2">
                    <custom-input
                        v-model="fileComponent.alt"
                        label="Slug"
                        :disabled="!enabledUpdate"
                    />
                </div>
            </div>

            <div class="flex h-10 my-4">
                <div v-if="enabledUpdate" class="w-full flex justify-center">
                    <app-button @click="updateFileComponent">
                        Actualizar archivo
                    </app-button>
                    <app-button
                        v-if="$ability.hasPermission('file:Delete')"
                        danger
                        @click="deleteFileComponent"
                    >
                        Eliminar archivo
                    </app-button>
                    <app-button
                        v-if="$ability.hasPermission('file:DeleteDefinitive')"
                        danger
                        @click="deleteFileDefinitelyComponent"
                    >
                        Eliminación definitiva
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { validateConfirmationMessage } from "@/common/lib/transformers";

import CustomInput from "@/components/utils/CustomInput.vue";

export default {
    name: "FileDetail",
    components: { CustomInput },
    data: () => ({
        id: 0,
        isLoading: false,
        enabledUpdate: true,
        loadedAllData: false,
        fileComponent: {
            id: 0,
            alt: "",
            url: "",
            private: false,
            createdAt: "2021-10-26T00:27:59.146Z",
            updatedAt: "2021-10-26T00:27:59.146Z",
            uploaded: false
        }
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"])
    },
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (!(await verifyPagePermission("file:Get", "/app/files"))) return;
        const id = Number(this.$route.params.id);
        this.id = id;
        await this.getBaseFile(id);
    },
    methods: {
        ...mapActions("files", [
            "getFileById",
            "updateFile",
            "deleteFile",
            "deleteFileDefinitively"
        ]),
        async getBaseFile(id) {
            this.isLoading = true;
            this.$loading.show();
            try {
                this.fileComponent = await this.getFileById({ id });
                this.loadedAllData = true;
                this.isLoading = false;
                this.$loading.hide();
            } catch (error) {
                this.isLoading = false;
                this.$loading.hide();
                this.isLoading = false;
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
                if (error.statusCode === 404) {
                    this.$router.push("/app/files");
                }
            }
        },
        async updateFileComponent() {
            this.isLoading = true;
            this.$loading.show();
            try {
                await this.updateFile(this.fileComponent);
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.$loading.hide();
                this.isLoading = false;
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$loading.hide();
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async deleteFileComponent() {
            const result = await this.$swal.fire({
                background: this.backgroundColor,
                title: "Estas seguro de eliminar el archivo ?",
                icon: "warning",
                confirmButtonColor: "#ee3f59",
                cancelButtonColor: "#253C99",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCancelButton: true
            });
            if (result.isConfirmed) {
                this.isLoading = true;
                this.$loading.show();
                try {
                    await this.deleteFile({
                        id: this.id
                    });
                    this.$router.push("/app/files");
                    this.$loading.hide();
                    this.isLoading = false;
                } catch (error) {
                    this.$loading.hide();
                    this.isLoading = false;
                    this.$loading.hide();
                    this.$swal.fire({
                        background: this.backgroundColor,
                        title: error.title,
                        text: error.message,
                        icon: error.icon
                    });
                }
            }
        },
        async deleteFileDefinitelyComponent() {
            const result = await this.$swal.fire({
                background: this.backgroundColor,
                title: "Estas seguro de eliminar el archivo definitivamente ?",
                icon: "warning",
                text: "Escribe 'Si' para eliminar en S3 también",
                input: "text",
                confirmButtonColor: "#ee3f59",
                cancelButtonColor: "#253C99",
                showCancelButton: true
            });
            if (
                result.isConfirmed &&
                validateConfirmationMessage(result.value)
            ) {
                this.isLoading = true;
                this.$loading.show();
                try {
                    await this.deleteFileDefinitively({
                        id: this.id
                    });
                    this.$router.push("/app/files");
                    this.$loading.hide();
                    this.isLoading = false;
                } catch (error) {
                    this.$loading.hide();
                    this.isLoading = false;
                    this.$loading.hide();
                    this.$swal.fire({
                        background: this.backgroundColor,
                        title: error.title,
                        text: error.message,
                        icon: error.icon
                    });
                }
            }
        },
        async copyTo() {
            await navigator.clipboard.writeText(`${this.fileComponent.url}`);
            this.$toast.success({
                title: "Copiado al porta papeles"
            });
        }
    }
};
</script>
